import { PlanTab } from '@/components/settings/Billing/PlanTab';
import { UsageTab } from '@/components/settings/Billing/UsageTab';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@superfunnel/ui-core/v2/Tabs';
import { Database, DollarCircle } from 'iconoir-react';
import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function BillingSettings() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedSubTab, setSelectedSubTab] = useState<string>(
    searchParams.get('tab') || 'plan',
  );

  useEffect(() => {
    setSearchParams((prev) => {
      prev.set('tab', selectedSubTab);
      return new URLSearchParams(prev);
    });
  }, [selectedSubTab, setSearchParams]);

  const subTabs = useMemo(
    () =>
      [
        {
          id: 'plan',
          icon: <DollarCircle className={'text-base-500 size-5'} />,
          name: 'Plan',
          current: false,
        },
        {
          id: 'usage',
          icon: <Database className={'text-base-500 size-5'} />,
          name: 'Usage',
          current: false,
        },
      ].map((c) => {
        c.current = c.id === selectedSubTab;
        return c;
      }),
    [selectedSubTab],
  );

  return (
    <Tabs
      defaultValue={selectedSubTab}
      onValueChange={setSelectedSubTab}
      orientation={'vertical'}
      className="grid h-full w-full grid-cols-1 gap-6 overflow-hidden bg-transparent md:grid-cols-[200px_1fr]"
    >
      <TabsList
        className={
          'h-min w-full flex-wrap items-start justify-start p-0 md:sticky md:top-0 md:flex-col'
        }
      >
        {subTabs.map((tab) => (
          <TabsTrigger
            value={tab.id}
            key={tab.id}
            className={
              'data-[state=active]:bg-base-100 h-auto flex-none justify-start gap-2.5 p-2 data-[state=active]:shadow-none md:w-full'
            }
          >
            {tab.icon} {tab.name}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="usage" className={'h-full overflow-y-auto'}>
        <UsageTab />
      </TabsContent>
      <TabsContent value="plan" className={'h-full overflow-y-auto'}>
        <PlanTab />
      </TabsContent>
    </Tabs>
  );
}
